<template>
	<div class="flex w-full space-x-4">
		<div>
			<TraitBadge v-if="model.badgeTrait" :trait="model.badgeTrait" />
			<slot v-else name="left" :model="model" />
		</div>

		<div
			class="flex-1 rounded-lg cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 focus-visible:ring-offset-2 focus-visible:ring-offset-neutral-900"
			role="button"
			tabindex="0"
			:aria-expanded="isOpen ? 'true' : 'false'"
			data-testid="row-accordion-toggle"
			@click="toggleOpen"
			@keydown.enter.prevent="toggleOpen"
			@keydown.space.prevent="toggleOpen"
		>
			<div class="flex items-center justify-between space-x-4">
				<div class="flex flex-col gap-0.5">
					<h4
						class="mb-0 text-xl leading-none text-white uppercase font-heading"
					>
						{{ model.title }}
					</h4>
					<h5 class="mb-0 font-normal text-neutral-300">
						{{ model.slogan }}
					</h5>
				</div>

				<div class="flex items-center gap-3">
					<slot name="right" :model="model" />

					<div
						class="flex items-center justify-center w-7 h-7 text-gray-500"
					>
						<Icon
							:icon="['far', 'chevron-down']"
							class="w-3 h-3 mb-0.5 transition-transform duration-150 transform"
							:class="stateClasses"
						/>
					</div>
				</div>
			</div>

			<div
				class="overflow-hidden transform"
				:class="trayClasses"
			>
				<p v-if="model.description" class="mt-3 text-neutral-300">
					{{ model.description }}
				</p>

				<slot v-else name="body" :open="isOpen" :model="model" />
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '~/components/ui/common/Icon'
import { TraitBadge } from '.'

export default {
	name: 'RowAccordion',
	components: {
		Icon,
		TraitBadge
	},
	inject: {
		personalityResultsExport: { default: null }
	},
	props: {
		model: {
			type: Object,
			required: true
		}
	},
	data() {
		return { open: false }
	},
	computed: {
		isExporting() {
			return Boolean(this.personalityResultsExport?.exporting)
		},
		isOpen() {
			return this.open || this.isExporting
		},
		stateClasses() {
			return this.isOpen ? 'rotate-180' : 'rotate-0'
		},
		trayClasses() {
			if (!this.isOpen) {
				return 'max-h-0 transition-all duration-500'
			}
			// Export capture: no clip, no transition that could be caught
			// mid-animation, and no max-h-72 ceiling on long content.
			if (this.isExporting) {
				return 'max-h-none'
			}
			return 'max-h-72 transition-all duration-500'
		}
	},
	methods: {
		toggleOpen() {
			this.open = !this.open
		}
	}
}
</script>
